function toBaseLocale(locale = '') {
    const dashIndex = locale.indexOf('-');
    if (dashIndex > -1) {
        return locale.slice(0, dashIndex);
    }
    const underscoreIndex = locale.indexOf('_');
    if (underscoreIndex > -1) {
        return locale.slice(0, underscoreIndex);
    }
    return locale;
}

export { toBaseLocale as default };
